import { FORM_CONTROL_FOCUS_RING } from '../../lib/a11yFocus'

type ElementProps<T extends keyof JSX.IntrinsicElements> = JSX.IntrinsicElements[T];

function InputCheckbox(props: ElementProps<"input">) {
    let classes = `h-4 w-4 border-white rounded-sm text-algae-500 cursor-pointer disabled:bg-charcoal-300 disabled:border-charcoal-300 disabled:text-charcoal-600 disabled:cursor-default active:ring-2 active:ring-transparent ${FORM_CONTROL_FOCUS_RING}`
    if(props.className) {
        classes += ' ' + props.className;
    }

    return <input {...props} className={classes} type="checkbox" data-testid='input-checkbox' />
}

export default InputCheckbox;
